export enum BiofaceResponseCode {
	ATIVACAO_SUCESSO = 1,
	VERIFICACAO_POSITIVA = 2,
	VERIFICACAO_NEGATIVA = 3,
	PESSOA_NAO_EXISTE = 4,
	ERRO_GENERICO = 7,
	PESSOA_JA_CADASTRADA = 191,
	CADASTRO_SUCESSO = 300,
	CADASTRO_ATUALIZADO = 301,
	PRECADASTRO_SUCESSO = 306,
	CONSULTA_OPERACOES_SUCESSO = 312,
	ERRO_ROSTO_IMAGEM = 800,
	ERRO_SALVAR_IMAGEM = 802,
	ROSTO_NAO_ENCONTRADO = 803,
	TEMPLATE_BAIXA_QUALIDADE = 804,
	TEMPLATE_INVALIDO = 806,
	ERRO_LER_FOTO_DOC = 807,
	ERRO_TEMPLATE_DOC = 808,
	ERRO_TEMPLATE_ROSTO = 809,
	ERRO_PARSE_JSON = 901,
	CAMPO_OBRIGATORIO = 902,
}

const SUCCESS_STATUS_LIST = [
	BiofaceResponseCode.CADASTRO_SUCESSO,
	BiofaceResponseCode.CADASTRO_ATUALIZADO,
];

const DIVERGENT_PHOTOS_STATUS_LIST = [
	BiofaceResponseCode.VERIFICACAO_NEGATIVA,
	BiofaceResponseCode.PESSOA_NAO_EXISTE,
	BiofaceResponseCode.ERRO_ROSTO_IMAGEM,
	BiofaceResponseCode.ERRO_SALVAR_IMAGEM,
	BiofaceResponseCode.ROSTO_NAO_ENCONTRADO,
	BiofaceResponseCode.TEMPLATE_BAIXA_QUALIDADE,
	BiofaceResponseCode.TEMPLATE_INVALIDO,
	BiofaceResponseCode.ERRO_LER_FOTO_DOC,
	BiofaceResponseCode.ERRO_TEMPLATE_DOC,
	BiofaceResponseCode.ERRO_TEMPLATE_ROSTO,
	BiofaceResponseCode.ERRO_PARSE_JSON,
	BiofaceResponseCode.CAMPO_OBRIGATORIO,
];

export {SUCCESS_STATUS_LIST, DIVERGENT_PHOTOS_STATUS_LIST};
